<template>
  <div>
    <div
      v-if="coverImage !== null"
      class="form-view__cover"
      :style="{ 'background-image': `url(${coverImage.url})` }"
    ></div>

    <form
      v-if="!submitted"
      class="form-view__body extras-mg-encuesta"
      @submit.prevent="alEnviar"
    >
      <div v-if="enPortada" class="form-view__heading">
        <Thumbnail v-if="logoImage !== null" :src="logoImage.url" width="200" />
        <h1 v-if="title !== ''" class="form-view__title">{{ title }}</h1>
        <div v-if="description !== ''" class="form-view__description">
          <FormViewDescription :value="description" read-only />
        </div>
        <div class="extras-mg-encuesta__acciones">
          <Button type="primary" size="large" @click.prevent="indice = 0">
            Empezar
          </Button>
        </div>
      </div>

      <template v-else>
        <div class="extras-mg-encuesta__progreso">
          <div
            class="extras-mg-encuesta__progreso-barra"
            :style="{ width: porcentaje + '%' }"
          ></div>
        </div>
        <div class="extras-mg-encuesta__contador">
          {{ indice + 1 }} de {{ visibleFields.length }}
        </div>

        <!--
          TODOS los campos se montan y solo se OCULTAN los que no tocan. No se
          usa v-if a proposito: al enviar, la pagina del formulario recorre
          `$refs['field-<id>'][0].isValid()` de cada campo visible SIN comprobar
          que exista, asi que un campo desmontado revienta el envio con
          "Cannot read properties of undefined". Se vio el 2026-09-09.

          Y se usan `values` y `updateValue` del mixin, no `modelValue`: el
          mixin guarda la copia que de verdad se envia.
        -->
        <FormPageField
          v-for="(campo, i) in visibleFields"
          :key="campo.field.id"
          :ref="'field-' + campo.field.id"
          :value="values['field_' + campo.field.id]"
          :slug="$route.params.slug"
          :field="campo"
          :class="{ hidden: i !== Math.max(indice, 0) }"
          @input="updateValue('field_' + campo.field.id, $event)"
        ></FormPageField>

        <div class="extras-mg-encuesta__acciones">
          <Button
            v-if="indice > 0"
            type="secondary"
            size="large"
            @click.prevent="indice--"
          >
            Atras
          </Button>
          <Button
            v-if="!esUltima"
            type="primary"
            size="large"
            @click.prevent="indice++"
          >
            Siguiente
          </Button>
          <Button
            v-else
            type="primary"
            size="large"
            :loading="loading"
            :disabled="loading"
          >
            {{ submitText }}
          </Button>
        </div>

        <FormViewPoweredBy v-if="showLogo"></FormViewPoweredBy>
      </template>
    </form>

    <FormViewSubmitted
      v-else-if="submitted"
      :is-redirect="isRedirect"
      :submit-action-redirect-url="submitActionRedirectUrl"
      :submit-action-message="submitActionMessage"
      :show-logo="showLogo"
    ></FormViewSubmitted>
  </div>
</template>

<script>
import baseFormViewMode from '@baserow/modules/database/mixins/baseFormViewMode'
import FormPageField from '@baserow/modules/database/components/view/form/FormPageField'
import FormViewPoweredBy from '@baserow/modules/database/components/view/form/FormViewPoweredBy'
import FormViewSubmitted from '@baserow/modules/database/components/view/form/FormViewSubmitted'
import FormViewDescription from '@baserow/modules/database/components/view/form/FormViewDescription'

/**
 * Modo encuesta: una pregunta a la vez.
 *
 * Reutiliza el mixin baseFormViewMode y el componente FormPageField del core,
 * que son los que saben pintar y validar cada tipo de campo. Lo unico propio es
 * la navegacion: portada, avanzar, retroceder y enviar en la ultima.
 */
export default {
  name: 'FormViewModeEncuesta',
  components: {
    FormPageField,
    FormViewPoweredBy,
    FormViewSubmitted,
    FormViewDescription,
  },
  mixins: [baseFormViewMode],
  data() {
    // -1 es la portada. Con titulo o descripcion se muestra primero; sin nada
    // que mostrar se entra directo a la primera pregunta.
    return { indice: -1 }
  },
  computed: {
    enPortada() {
      return this.indice < 0 && (this.title !== '' || this.description !== '')
    },
    campoActual() {
      const i = Math.max(this.indice, 0)
      return this.visibleFields[i] || null
    },
    esUltima() {
      return Math.max(this.indice, 0) >= this.visibleFields.length - 1
    },
    porcentaje() {
      if (!this.visibleFields.length) {
        return 0
      }
      return ((Math.max(this.indice, 0) + 1) / this.visibleFields.length) * 100
    },
  },
  methods: {
    alEnviar() {
      if (this.esUltima) {
        this.$emit('submit')
      } else {
        this.indice++
      }
    },
  },
}
</script>

<style lang="scss">
.extras-mg-encuesta__progreso {
  height: 4px;
  border-radius: 2px;
  background: color-mix(in srgb, currentColor 12%, transparent);
  margin-bottom: 6px;
  overflow: hidden;
}

.extras-mg-encuesta__progreso-barra {
  height: 100%;
  background: #5190ef;
  transition: width 0.2s ease;
}

.extras-mg-encuesta__contador {
  font-size: 11px;
  opacity: 0.55;
  margin-bottom: 18px;
}

.extras-mg-encuesta__acciones {
  display: flex;
  gap: 10px;
  margin-top: 24px;
}
</style>
